import CarouselTest from "../components/CarouselTest";

const DataDapps = () => {
    return (
        <CarouselTest/>
    )
}

export default DataDapps;
